import { render } from "./Lgfourteen.vue?vue&type=template&id=4d83851d&scoped=true"
import script from "./Lgfourteen.vue?vue&type=script&lang=js"
export * from "./Lgfourteen.vue?vue&type=script&lang=js"

import "./Lgfourteen.vue?vue&type=style&index=0&id=4d83851d&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d83851d"]])

export default __exports__